export default "__VITE_PUBLIC_ASSET__272dcace__"